const authRoutes = [
  {
    title: 'Sign in',
    fullTitle: 'Sign in',
    icon: 'user',
    titleIcon: true,
    path: '/auth/sign-in',
    default: true,
  },
];

export default authRoutes;
